import { ethers } from 'ethers';

const INVOICE_NFT_ABI = [
  "function mintInvoice(uint256 _amount, uint256 _dueDate, address _debtorAddress, uint8 _riskScore, string memory _ipfsHash) public returns (uint256)",
  "function getInvoice(uint256 _tokenId) public view returns (tuple(uint256 tokenId, uint256 amount, uint256 dueDate, address debtorAddress, address msmeAddress, uint8 riskScore, string ipfsHash, uint8 status))",
  "function getTotalSupply() public view returns (uint256)",
  "function ownerOf(uint256 tokenId) public view returns (address)",
  "event InvoiceMinted(uint256 indexed tokenId, address indexed msmeAddress, uint256 amount, uint256 dueDate, uint8 riskScore)",
  "event InvoiceStatusUpdated(uint256 indexed tokenId, uint8 newStatus)"
];

const ESCROW_ABI = [
  "function acceptFinancing(uint256 _invoiceId) public payable",
  "function getInvestor(uint256 _invoiceId) public view returns (address)",
  "function getDeposit(uint256 _invoiceId) public view returns (uint256)",
  "event FinancingAccepted(uint256 indexed invoiceId, address indexed investor, uint256 amount)",
  "event FundsReleased(uint256 indexed invoiceId, address indexed msme, uint256 amount, uint256 platformFee)"
];

const PAYOUT_ABI = [
  "function markAsPaid(uint256 _invoiceId) public payable",
  "function calculatePayoutAmount(uint256 _principal, uint8 _riskScore) public pure returns (uint256)",
  "event InvoicePaid(uint256 indexed invoiceId, address indexed investor, uint256 principalAmount, uint256 yieldAmount)",
  "event InvoiceDefaulted(uint256 indexed invoiceId, address indexed investor)"
];

export const getInvoiceNFTContract = (signerOrProvider, address) => {
  if (!address) return null;
  return new ethers.Contract(address, INVOICE_NFT_ABI, signerOrProvider);
};

export const getEscrowContract = (signerOrProvider, address) => {
  if (!address) return null;
  return new ethers.Contract(address, ESCROW_ABI, signerOrProvider);
};

export const getPayoutContract = (signerOrProvider, address) => {
  if (!address) return null;
  return new ethers.Contract(address, PAYOUT_ABI, signerOrProvider);
};

export const parseInvoiceStatus = (status) => {
  const statuses = ['LISTED', 'FUNDED', 'PAID', 'DEFAULTED'];
  return statuses[status] || 'UNKNOWN';
};

export const formatAddress = (address) => {
  if (!address) return '';
  return `${address.slice(0, 6)}...${address.slice(-4)}`;
};

export const calculateExpectedYield = (amount, riskScore) => {
  const yieldPercent = 15 + (riskScore - 1);
  return (amount * yieldPercent) / 100;
};

export const calculateAPY = (riskScore) => {
  return 15 + (riskScore - 1);
};